$(document).ready(function(){
   $(".custom_drawer_accordion > .first_child_box svg.path_icon_menu").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    $(this).closest('.custom_drawer_accordion > .first_child_box').siblings(".first_child_box_submenu").slideUp(200);
     // $(".custom_drawer_accordion > .first_child_box i").removeClass("fa-minus").addClass("fa-plus");
    } else {
     // $(".custom_drawer_accordion > .first_child_box i").removeClass("fa-minus").addClass("fa-plus");
     // $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".custom_drawer_accordion > .first_child_box svg.path_icon_menu").removeClass("active");
      $(this).addClass("active");
      $(".first_child_box_submenu").slideUp(200);
       $(this).closest('.custom_drawer_accordion > .first_child_box').siblings(".first_child_box_submenu").slideDown(200);
      
    }
  });

 $(".footer-block.grid__item.footer-block--menu > .footer-accordion__heading").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings("ul.footer-block__details-content").slideUp(200);
      $(".footer-block.grid__item.footer-block--menu > .footer-accordion__heading i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".footer-block.grid__item.footer-block--menu > .footer-accordion__heading i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".footer-block.grid__item.footer-block--menu > .footer-accordion__heading").removeClass("active");
      $(this).addClass("active");
      $("ul.footer-block__details-content").slideUp(200);
      $(this).siblings("ul.footer-block__details-content").slideDown(200);
    }
  });
  
  
    // filter summary off js
     $(document).on('click', '#desktop-filter-apply , #ProductGridContainer , .collection-hero .collection-hero__inner ,.header-wrapper', function(){  
        $("details.filter_option").removeAttr("open");
    });
   
  // filter option class add js
    $(document).on('click', '.cstm_filter .list-menu__item .custom_param_name ', function(){   
       $(this).toggleClass('tag_active'); 
       return false;
    });
  
   // filter Clear All button click js
    $(document).on('click', '.active-facets__button-wrapper a.active-facets__button-remove.underlined-link', function(){  
      
       $(".cstm_filter .list-menu__item .custom_param_name").removeClass("tag_active");
       $(".cstm_filter .list-menu__item .custom_param_name").removeClass("active");
       $(".cstm_filter .list-menu__item .custom_param_name").removeClass("activeMaterial");
       $(".custom_param_name ").removeClass("disabled");
     
    });
  
  // $(document).on('click', '.custom_param_name', function(){
  //   var _this = $(this).attr('data-cTag');
  //   $('.custom_forloop_index').each(function(){
  //     var tag = $(this).attr('data-tag');
  //     if(_this == tag){
  //        console.log('tag' + tag);  
  //        $(this).trigger('click');
  //        $(this).find('label *').trigger("click");
  //        $(this).find('label').find('input').prop("checked", true);  
  //         // if($(this).is(':checked')){
  //         //    $(this).find('label').find('input').prop("checked", true);  
  //         //   $(this).trigger('click');
  //         // } else {
  //         //     $(this).find('label').find('input').prop("checked", false);  
  //         //   $(this).trigger('click');
  //         // }
  //     }
  //   });
  // });

// custom collection page filter id click in js
   var data_vlu = $(this).attr('data-cTag');
  $('li.custom_forloop_index[data-tag="'+data_vlu+'"]').find('label *').trigger("click");
   $('li.custom_forloop_index label.disabled').each(function () {
      var data_tag = $(this).parents('li').data('tag');
      $('label[data-ctag="'+data_tag+'"]').addClass('disabled');
    });  
     $('label.facets__label.facet-checkbox').each(function () {
        if (!$(this).hasClass("disabled")){
          var data_tag = $(this).parents('li').data('tag');  
          $('label[data-ctag="'+data_tag+'"]').removeClass('disabled');
        }
     }); 

    $('li.custom_forloop_index label.active').each(function () {
          var data_tag = $(this).parents('li').data('tag');  
          $('label[data-ctag="'+data_tag+'"]').addClass('active');
     });
      
      $('label.facets__label.facet-checkbox').each(function () {
        if (!$(this).hasClass("active")){
          var data_tag = $(this).parents('li').data('tag');  
          $('label[data-ctag="'+data_tag+'"]').removeClass('active');
        }
    });
  
$(document).on('click', '.custom_param_name', function(){
   var data_vlu = $(this).attr('data-cTag');
    $('li.custom_forloop_index[data-tag="'+data_vlu+'"]').find('label *').trigger("click");
      
    setTimeout(()=>{
      $('li.custom_forloop_index label.disabled').each(function () {
      var data_tag = $(this).parents('li').data('tag');
      // console.log(data_tag);
      $('label[data-ctag="'+data_tag+'"]').addClass('disabled');
    });
    
    $('label.facets__label.facet-checkbox').each(function () {
        if (!$(this).hasClass("disabled")){
          var data_tag = $(this).parents('li').data('tag');  
          $('label[data-ctag="'+data_tag+'"]').removeClass('disabled');
        }
    });
    $('li.custom_forloop_index label.active').each(function () {
          var data_tag = $(this).parents('li').data('tag');  
          $('label[data-ctag="'+data_tag+'"]').addClass('active');
     });
      
      $('label.facets__label.facet-checkbox').each(function () {
        if (!$(this).hasClass("active")){
          var data_tag = $(this).parents('li').data('tag');  
          $('label[data-ctag="'+data_tag+'"]').removeClass('active');
        }
     });
      
  },2000); 
}); 
 
  $('.custom_forloop_index').each(function(){
    var activeFilterVal =   $(this).find('label.facets__label.facet-checkbox.active').find('input').attr('data_value');
    $('.custom_param_name[data-ctag="'+activeFilterVal+'"]').addClass('tag_active');
  });
  
  $(document).on('click', '.cstm_filter .filter_single.box_1 .list-menu__item .custom_param_name', function(){ 
  $(this).toggleClass('activeMaterial');
  var activeMaterial = $(this).parents('.list-menu__item').siblings('.list-menu__item').find('.activeMaterial').attr('data-ctag');  
    $('li.custom_forloop_index[data-tag="'+activeMaterial+'"]').find('label').trigger("click");         
    $('.custom_param_name[data-ctag="'+activeMaterial+'"]').removeClass('tag_active');
    $('.custom_param_name[data-ctag="'+activeMaterial+'"]').removeClass('activeMaterial');
 });
  
 // collection page SortBy js 
  $(document).on('click', '#custom_SortBy li', function(){ 
    var sortVal = $(this).attr('data_value');
    $('#SortBy option').each(function(){
      var _this = $(this);
      var selVal = $(this).val();
      if(sortVal == selVal){
     //   console.log(selVal);
       _this.trigger('change');
       _this.val(selVal);
       _this.prop('selected', true);
            $("#SortBy option[value='+ selVal +']").prop('selected', true); 
            $("#SortBy option[value='+ selVal +']").trigger('change');
            $('#customSel').val(selVal);
      }
    });    
  });

 // home page slide js  
  var swiper = new Swiper(".image_text_slide",{
        slidesPerView: 1,
        spaceBetween: 0, 
        speed: 3000,
        // effect: 'fade',
        loop: true,
        autoplay: {
          enabled: true,
          delay:1000,
          disableOnInteraction: false,
        },
        fadeEffect: {
          crossFade: true
       },
       
        breakpoints: {
          768: {
            slidesPerView: 1
          },
          576: {
             slidesPerView: 1
         }
        }
  }); 
  // home page Testimonial section js
  var mySwiper = new Swiper ('.slider_Testimonial', {
    observer: true,
  	observeParents: true,
  	loop: true,
  	loopedSlides: 4,
  	slidesPerView: 1,
  	speed: 2000,
  	autoplay: {
  	  delay: 10000,
  	  disableOnInteraction: true,
  	},
  }); 
  
// instafeed section slider js
var mySwiper = new Swiper ('.instafeed_slider_box', {
  spaceBetween: 10,
  direction: 'horizontal', 
  centeredSlides: true,
  loop: true, 
  grabCursor: true,
  centeredSlidesBounds: true,
  slideToClickedSlide: true,
  simulateTouch: false,
  autoplay: {
    enabled: true,
    delay: 0,
    disableOnInteraction: false,
  },
  centerInsufficientSlides: true,
  speed: 6000,
  effect: 'slide',
  loopAdditionalSlides: 0,
  breakpoints: {
    768: {
        slidesPerView: 4
    },
    576: {
        slidesPerView: 3
    }
  }
}); 

//-- manu hover ----
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
});

// ------------Product page js-------------
  $(document).on("change",".cstm_input",function() {
  var input_name = $(this).attr('name');
  var input_Color = $("input[name='" +input_name+ "']:checked").val();
  $(this).closest('.product-form__input').find('.sel_variant').text(input_Color);
});

 //----------- header sticky js--------------
$(window).scroll(function(){
  // var sticky = $('.header--top-center'),
  var header = $('.header--top-center'),
      announcementBar = $('.announcement-bar-section'),
      scroll = $(window).scrollTop();

  // if (scroll >= 100) sticky.addClass('custom_fixed');
  // else sticky.removeClass('custom_fixed');
  if (scroll >= 100) {
    announcementBar.addClass('announcement_fixed');
    header.addClass('custom_fixed').css('top', announcementBar.outerHeight() + 'px');
  } else {
    announcementBar.removeClass('announcement_fixed');
    header.removeClass('custom_fixed').css('top', '');
  }
});
  
//----------- collection sticky js--------------
$(window).scroll(function(){
  var sticky = $('.custom_filter'),
      announcementBar = $('.announcement-bar-section'),
      header = $('.header--top-center'),
      scroll = $(window).scrollTop();

  // if (scroll >= 100) sticky.addClass('custom_sticky');
  // else sticky.removeClass('custom_sticky');
  if (scroll >= 100) {
    sticky.addClass('custom_sticky').css('top', (announcementBar.outerHeight() + header.outerHeight()) + 'px');
  } else {
    sticky.removeClass('custom_sticky').css('top', '');
  }
}); 
  
// -------------product size popup js------------ 
  $(".size_icon_click").click(function () {
     $(".show_box_popup").show();
  });
  $(".close_icon_box ").click(function () {
     $(".show_box_popup").hide();
  });

  $(".message_icon.drop_message a").click(function () {
     $(".popup_contact_form").show();
  });
  $(".Popup_contact_close ").click(function () {
     $(".popup_contact_form").hide();
  });
   
  // ------------collection page Scroll-------------
   var scroll_enable = $('#product-grid').attr('data-scroll');
    if(scroll_enable == 'enabled'){
   // var scroll_function = function scroll_function() {
   //   var endlessScroll = new Ajaxinate({
   //      container: '#product-grid',
   //      pagination: '#Huratips-Pagination',
   //      loadingText: 'Load More', 
   //      method: "scroll",
   //    });
   //    };
   // Custom Collection infinite scroll
    $(window).on('scroll', function() {
      if( $(document).find('#Huratips-Pagination a').hasClass('loading') ){}else{
        $(document).find('#Huratips-Pagination a').addClass('loading').click();
      }
    });
    $(document).on('click','#Huratips-Pagination a',function(e) {
      e.preventDefault();
      var scrollURL = $(this).attr("href");
      $.ajax({
         type: 'GET',
         url: scrollURL,
         beforeSend: function(){},
         success: function(data) {
             if( $(data).find("#Huratips-Pagination").length ){                 
               var moreButton = $(data).find("#Huratips-Pagination").html();
               $(document).find("#Huratips-Pagination").html(moreButton);  
             }else{                 
               $(document).find("#Huratips-Pagination").remove();  
               $(document).find('.order_2').addClass('active');
             }
             var filteredData = $(data).find("#product-grid").html();
             $(document).find("#product-grid").append(filteredData);             
         },
         dataType: "html"
     });
    });
    }

  


// $(document).on("click", "a.active-facets__button-remove.underlined-link", function() {
// var scrollURL = $('a.paginate_button').attr("href");
//     $.ajax({
//             type: 'GET',
//             url: scrollURL,
//             dataType: 'html',
//             success: function(data) { 
//             //   $(data).find("#Huratips-Pagination").html();   
//             //   $(document).find("#Huratips-Pagination").html($(data).find("#Huratips-Pagination").html());   
//               // scroll_function(); 
//             }
//         });
// });


// Fetch all the details element.
const details = document.querySelectorAll(".filter_bar__options .filter_option");
// Add the onclick listeners.
details.forEach((targetDetail) => {
  targetDetail.addEventListener("click", () => {
    // Close all the details that are not targetDetail.
    details.forEach((detail) => {
      if (detail !== targetDetail) {
        detail.removeAttribute("open");
      }
    });
  });
});


if ($(window).width() < 1000) { 
 $(".filter_single h3.filter_label").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".filter_tag_accident ,ul.facets__list.list-unstyled").slideUp(200);
      $(".filter_single h3.filter_label i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".filter_single h3.filter_label i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".filter_single h3.filter_label").removeClass("active");
      $(this).addClass("active");
      $(".filter_tag_accident ,ul.facets__list.list-unstyled").slideUp(200);
      $(this).siblings(".filter_tag_accident ,ul.facets__list.list-unstyled").slideDown(200);
    }
  });
 } 


 
 
  
$(document).on('change', '#toSlider', function() {
    $('.max_price_normal').html( $(this).val() );
});
$(document).on('change', '#fromSlider', function() {
    $('.min_price_normal').html( $(this).val() );
}); 
  
controlFromInputmain();
function controlFromInputmain() {
  function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#000', '#000', controlSlider);
    if (from > to) {
        fromSlider.val(to);
        fromInput.val(to);
    } else {
        fromSlider.val(from);
    }
}

function controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#000', '#000', controlSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
        toSlider.val(to);
        toInput.val(to);
    } else {
        toInput.val(from);
    }
}

function controlFromSlider(fromSlider, toSlider, fromInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#000', '#000', toSlider);
    if (from > to) {
        fromSlider.val(to);
        fromInput.val(to);
    } else {
        fromInput.val(from);
    }
}

function controlToSlider(fromSlider, toSlider, toInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#000', '#000', toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
        toSlider.val(to);
        toInput.val(to);
    } else {
        toInput.val(from);
        toSlider.val(from);
    }
}

function getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.val(), 10);
    const to = parseInt(currentTo.val(), 10);
    return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to.prop('max') - to.prop('min');
    const fromPosition = from.val() - to.prop('min');
    const toPosition = to.val() - to.prop('min');
    controlSlider.css('background', `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
        ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
        ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
        ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
        ${sliderColor} 100%)`);
}

function setToggleAccessible(currentTarget) {
    const toSlider = $('#toSlider');
    if (Number(currentTarget.val()) <= 0) {
        toSlider.css('z-index', 2);
    } else {
        toSlider.css('z-index', 0);
    }
}

 
    const fromSlider = $('#fromSlider');
    const toSlider = $('#toSlider');
    const fromInput = $('.custom_GTE_data');
    const toInput = $('.custom_toInput_data');

    fillSlider(fromSlider, toSlider, '#000', '#000', toSlider);
    setToggleAccessible(toSlider);

    $(document).on('input','#fromSlider', function () {
    const fromSlider = $(document).find('#fromSlider');
    const toSlider = $(document).find('#toSlider');
    const fromInput = $(document).find('.custom_GTE_data');
    const toInput = $(document).find('.custom_toInput_data');
    controlFromSlider(fromSlider, toSlider, fromInput);
    });

    $(document).on('input','#toSlider',function () {
   const fromSlider = $(document).find('#fromSlider');
    const toSlider = $(document).find('#toSlider');
    const fromInput = $(document).find('.custom_GTE_data');
    const toInput = $(document).find('.custom_toInput_data');
    controlToSlider(fromSlider, toSlider, toInput);
    });

    $(document).on('input','.custom_GTE_data', function () {
    const fromSlider = $(document).find('#fromSlider');
    const toSlider = $(document).find('#toSlider');
    const fromInput = $(document).find('.custom_GTE_data');
    const toInput = $(document).find('.custom_toInput_data');
    controlFromInput(fromSlider, fromInput, toInput, toSlider);
    });

    $(document).on('input','.custom_toInput_data', function () {
    const fromSlider = $(document).find('#fromSlider');
    const toSlider = $(document).find('#toSlider');
    const fromInput = $(document).find('.custom_GTE_data');
    const toInput = $(document).find('.custom_toInput_data');
    controlToInput(toSlider, fromInput, toInput, toSlider);
    });
 

}


 });


